module.exports = __webpack_public_path__ + "img/IMG_0900.a37ac482.jpeg";